import { RedirectMdIcon } from '@crono-one/design-system';
import { withProtocol } from 'crono-fe-common/utils';

export interface ExternalLinkButtonProps {
  /** Url of the link, if the protocol is missing `https` is added. */
  href: string;
  /** Accessible name of the link. */
  label: string;
}

/** An icon-only link that opens the address in a new tab, adding the `https` protocol if missing. */
const ExternalLinkButton = ({ href, label }: ExternalLinkButtonProps) => (
  <a
    href={withProtocol(href)}
    target="_blank"
    rel="noopener noreferrer"
    aria-label={label}
    title={label}
    className="size-6 shrink-0 flex items-center justify-center rounded-md text-gray-700 outline-hidden hover:bg-neutral-100 hover:text-gray-900 focus-visible:ring-3 focus-visible:ring-primary-700/50"
  >
    <RedirectMdIcon className="size-4" />
  </a>
);

export default ExternalLinkButton;
